export enum AccessGroup {
  NoChange = 'NO_CHANGE',
  NoAccess = 'NO_ACCESS',
  EditRead = 'EDIT_READ',
  ReadOnly = 'READ_ONLY',
  ProgramAccountManager = 'PROGRAM_ACCOUNT_MANAGER',
  BusinessAccountManager = 'BUSINESS_ACCOUNT_MANAGER',
  ProgramManager = 'PROGRAM_MANAGEMENT',
  BusinessManager = 'BUSINESS_MANAGEMENT',
  Expired = 'EXPIRED',
}

/**
 * Permssion types are coming from backend - backend call this Role
 */
export enum PermissionType {
  NoAccess= 'NoAccess',
  Edit = 'EDIT',
  Read = 'READ',
  Admin = 'ADMIN',
  Manager = 'MANAGER',
}
